import React from "react";
import "./App.css";
import Main from "./components/Main";
import "./index.css";

const App = () => (
  <div className="off-canvas-wrapper">
    <Main />
    <hr />
  </div>
);

export default App;
